module.exports = __webpack_public_path__ + "img/sidebar-setting.a1469c04.svg";